<template>
  <div>
    <header class="flex-end">
      <el-button
        type="primary"
        @click="open"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        type="index"
        label="序号"
        width="180"
      ></el-table-column>
      <el-table-column label="配置类型">
        <template>模型管理后台配置</template>
      </el-table-column>
      <el-table-column label="配置内容">
        <template slot-scope="scope">
          <p>clintID:{{scope.row.bimClientId}}</p>
          <p>clintsecret:{{scope.row.bimClientSecret}}</p>
        </template></el-table-column>
      <el-table-column
        prop="createTime"
        label="绑定时间"
      ></el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleEdit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="handleDel(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <edit-dialog
      ref="editDialog"
      @updateList="handlerSearch"
    ></edit-dialog>

  </div>
</template>

<script>
import {
  Api_role, Api_setting
} from '@/api/api'
import EditDialog from './editDialog'
export default {
  components: {
    EditDialog,
  },
  data() {
    return {
      tableData: [],
    };
  },
  created() {
    this.handlerSearch()
  },
  methods: {
    open() {
      this.$refs.editDialog.open()
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.handlerSearch()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.handlerSearch()
    },
    handleEdit(val) {
      this.$refs.editDialog.open(val)
    },
    handleDel(val) {
      this.$confirm('是否删除此条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api_setting.delPkConfig(val).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.handlerSearch()
        })
      })
    },
    handleChange(value) {
      console.log(value)
    },
    handlerSearch() {
      Api_setting.getPkAccount().then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.$set(this, 'tableData', [result.data])
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-end {
  display: flex;
  justify-content: flex-end;
}
</style>